import React, { useState, useEffect } from 'react';
import { Box, Button, List, ListItem, Paper, Typography } from '@material-ui/core'
import ChannelsTable from './channelsTable';
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles'
import Search from '../search';
import Plus from '../assets/icons/white-plus.png'
import { Link, useLocation } from "react-router-dom";
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import Snackbar from '../common/snackbar';
import axios from 'axios';
import { baseApiUrl } from '../dataProvider/sails';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import { onRawFileOpen, open } from '../convert-dvb-tv-channel';
import { usePopupState, bindToggle } from "material-ui-popup-state/hooks";
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow';

const useStyles = makeStyles(theme => ({
    TitleUser: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    borderCreate: {
        borderRadius: '10px',
    },
    textbtnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer !important',
        opacity: 0,
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    },
    Title: {
        fontFamily: "UniviaPro-Bold",
        fontSize: '13px',
        letterSpacing: '0.13px ',
        lineHeight: '16.3px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        color: '#4f5064'
    },
    Close: {
        fontFamily: "UniviaPro",
        fontSize: '10px',
        letterSpacing: '0.4px ',
        lineHeight: '12.5px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
    },
    textTab: {
        fontSize: 13,
        color: '#4f5064',
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
        fontStyle: 'normal',
        fontStretch: 'normal',
        padding: '5px'
    }
}));
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};


const ChannelList = () => {
    const classes = useStyles()
    const translate = useTranslate()
    const [search, setSearch] = React.useState('')
    const { permissions, loaded } = usePermissions();
    const [data, setData] = React.useState([])
    const [total, setTotal] = React.useState()
    const [loadingPage, setLoadingPage] = useState()
    const [success, setSuccess] = useState(false)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [checked, setChecked] = useState([])
    const [showSnackbar, setShowSnackbar] = useState(false)
    const dataProvider = useDataProvider()
    const location = useLocation();
    const [messageSnackbar, setMessageSnackbar] = useState({ name: '', message: '' });
    const [loading, setLoading] = useState(false);
    const popupState = usePopupState({ variant: 'popper', popupId: 'importChannelDialog' });
    const [sort, setSort] = useState({
        field: 'name',
        order: 'ASC'
    })
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10
    })

    const action = (
        <Button color="secondary" size="small" onClick={() => {
            setSuccess(false)
        }}>
            {translate('resources.room.close')}
        </Button>
    );

    const getListChannel = () => {
        let filter = {}
        if (search.trim() && search.length > 0) {
            filter = {

                or: [
                    { name: { contains: search.trim() } },
                    { internalName: { contains: search.trim() } },
                    { type: { contains: search.trim() } },
                    { epgId: { contains: search.trim() } },
                ]
            };

            // Avoid checking type of sails
            // For type number field
            if (!isNaN(search.trim())) {
                filter.or.push(...[
                    { number: parseInt(search.trim()) },
                ]);
            }
        }
        dataProvider('GET_LIST', "channel", {
            filter,
            sort,
            pagination
        }).then(({ data, total }) => {
            setData(data)
            setTotal(total)

        }).catch(error => {

        });
    }

    const onGetListChannel = (sortObj, paginationObj) => {
        setSort(sortObj)
        setPagination(paginationObj)
    }

    const fileRawTVOnChange = event => {
        popupState.close();
        var files = [...event.target.files]
        if (files && files.length === 1) {
            var file = files[0];
            try {
                const fileReader = new FileReader();
                fileReader.readAsArrayBuffer(file);
                fileReader.onload = function () {
                    setLoading(true);
                    open(fileReader.result).then(async () => {
                        const channels = await onRawFileOpen();
                        dataProvider('CREATE', "channels/import-channel-list", {
                            data: {
                                channels: channels
                            }
                        }).then(({ data }) => {
                            getListChannel();
                            setLoading(false);
                        }).catch(error => {
                            setLoading(false);

                        });
                    });
                };
            } catch (err) {
                console.log(err);
                return null;
            }
        }
    }

    const fileBrowserOnChange = event => {
        popupState.close();
        var files = [...event.target.files]
        if (files && files.length === 1) {
            setLoading(true);
            var file = files[0];
            const formData = new FormData();
            formData.append('file', file);
            axios
                .post(`${baseApiUrl}/channels/import`, formData)
                .then(response => {
                    getListChannel();
                    setMessageSnackbar({ name: "Import sucess:", message: `${file.name} is imported succesfully.` });
                    setShowSnackbar(true);
                    setTimeout(() => {
                        setShowSnackbar(false);
                    }, 6000);
                    setLoading(false);
                })
                .catch(error => {
                    console.error('Import channel file error:', error);
                    setMessageSnackbar({ name: "Import error:", message: error.message });
                    setShowSnackbar(true);
                    setTimeout(() => {
                        setShowSnackbar(false);
                    }, 6000);
                    file.error = true;
                    setLoading(false);
                });
        }
    }

    useEffect(() => {
        getListChannel();
    }, [sort, pagination])

    const onChangeFilter = (event) => {
        setSearch(event.target.value)
    }

    const handleDelete = () => {
        var requests = []
        data.forEach(element => {
            element.checked && requests.push(
                dataProvider('DELETE', "channel", {
                    id: element.id
                })
            )
        })
        if (requests.length > 0) {
            Promise.all(requests).then(() => {
                getListChannel()
                setOpenConfirmDialog(false)
            }).catch(error => {
                setOpenConfirmDialog(false)
            });
        }
        else
            setOpenConfirmDialog(false)

    }

    const handleCheckMark = (event, index, checkAll) => {
        let temps = data.slice()
        if (!checkAll)
            temps[index].checked = event.target.checked
        else
            temps.map(item => {
                item.checked = event.target.checked
                return item
            })
        setData(temps)
    }

    const onClear = () => {
        let temps = data.slice()
        temps.map(item => {
            delete item.checked
            return item
        })
        setData(temps)
    }

    React.useEffect(() => {
        getListChannel()
        if (location.state && location.state.open) {
            setShowSnackbar(true);
            setTimeout(() => {
                setShowSnackbar(false);
            }, 6000);
        }
    }, []);

    if (!loaded) return null;
    if (loading) return <Loading />;
    return (
        <Box width="100%" display='flex' justifyContent='center' pt={2}>
            <Box width="90%">
                <Box width='100%' display='flex' justifyContent='flex-end'>
                    <Snackbar
                        show={showSnackbar}
                        boldText={(location.state && location.state.name) || messageSnackbar.name}
                        message={location.state && location.state.message || messageSnackbar.message}
                        onClose={() => setShowSnackbar(false)}
                    />

                </Box>
                <Box display="flex" py={3}>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center" >
                        <Typography className={classes.TitleUser} color="textPrimary">{translate(`pos.channels.list`)}</Typography>
                        {
                            total > 0 ? <Typography className={classes.subText}>({total})</Typography>
                                : <Typography className={classes.subText}>(0)</Typography>
                        }
                    </Box>
                    <Box flexGrow={1} display='flex' justifyContent='flex-end'>
                        <Search
                            placeholder={translate(`pos.channels.search`)}
                            onChangeText={setSearch}
                            getList={getListChannel}
                        />

                        {
                            permissions.functionAction.find(value => value.function === 'Channels and programs' && value.isUpdate) &&
                            <Box display='flex' justifyContent='flex-end' my='auto' ml={4}>
                                <Button variant='contained'
                                    color='primary'
                                    {...bindToggle(popupState)}
                                    endIcon={<ImportExportIcon />}
                                >
                                    {
                                        <Typography className={classes.textbtnCreate}>{translate(`pos.channels.import`)}</Typography>
                                    }
                                </Button>
                                <CustomPopoverArrow
                                    zIndex={1500}
                                    popupState={popupState}
                                    placement='left-start'
                                >
                                    <Paper style={{ width: 170 }}>
                                        <Box p={2} pb={0}>
                                            <Typography className={classes.Title} > {translate("pos.channels.importFromFileType")}</Typography>
                                        </Box>

                                        <List style={{ paddingTop: 10 }} component="nav">
                                            <ListItem button>
                                                <Box>
                                                    <Typography className={classes.textTab} >{translate("pos.channels.importFromCSVFile")}</Typography>
                                                    <input type='file' onChange={fileBrowserOnChange} className={classes.input} />
                                                </Box>
                                            </ListItem>
                                            <ListItem button>
                                                <Box>
                                                    <Typography className={classes.textTab} >{translate("pos.channels.importFromRawChannelFile")}</Typography>
                                                    <input type='file' onChange={fileRawTVOnChange} className={classes.input} />
                                                </Box>
                                            </ListItem>
                                        </List>
                                        <Box display='flex' justifyContent='flex-end'>
                                            <Button
                                                color='primary'
                                                type='button'
                                                style={{ marginRight: '1rem', marginBottom: '10px' }}
                                                onClick={() => popupState.close()}
                                            ><Typography className={classes.Close} >{translate('pos.common.close')}</Typography></Button>
                                        </Box>
                                    </Paper>
                                </CustomPopoverArrow>
                                <Button
                                    variant="contained"
                                    color='primary'
                                    className={classes.borderCreate}
                                    endIcon={<img src={Plus} height={18} style={{ width: "18px" }} />}
                                    component={Link}
                                    to={{ pathname: '/channel/create' }}
                                    style={{ marginLeft: '16px' }}
                                >
                                    <Typography className={classes.textbtnCreate}>{translate(`pos.channels.addChannel`)}</Typography>
                                </Button>
                            </Box>
                        }
                    </Box>
                </Box>
                <Box mt={1}>
                    <ChannelsTable
                        buttonHidden={
                            !permissions.functionAction.find(value => value.function === 'Channels and programs' && value.isUpdate)
                        }
                        checked={data.length > 0 && data.filter(item => item.checked)}
                        handleCheckMark={handleCheckMark}
                        loading={loadingPage}
                        data={data}
                        setData={setData}
                        total={total}
                        getList={onGetListChannel}
                        onClear={onClear}
                        onDelete={() => {
                            setOpenConfirmDialog(true)
                        }}
                        error={data.length}
                    />
                </Box>
                <ConfirmDialog
                    open={openConfirmDialog}
                    handleClose={() => { setOpenConfirmDialog(false) }}
                    handleConfirm={handleDelete}
                    ContentText={translate(`pos.channels.confirmDelete`)}
                    Tittle={translate(`pos.channels.delete`)} />
            </Box>
        </Box>

    )
}

export default ChannelList